import api from './api';

export interface PosTerminal {
  id: number;
  entidadeId: string;
  entidadeNome: string | null;
  deviceId: string;
  deviceName: string | null;
  deviceType: string | null;
  estado: 'ACTIVE' | 'INACTIVE' | 'BLOCKED';
  ultimaActividade: string | null;
  ultimoLogin: string | null;
  criadoEm: string;
  sessoesActivas: number;
  /** Código do agente, quando a entidade está registada como tal. */
  agenteCodigo: string | null;
  /** Sem agente activo, o carregamento em numerário é recusado. */
  aceitaNumerario: boolean;
}

export interface PosFecho {
  id: number;
  referencia: string;
  entidadeNome: string | null;
  terminalNome: string | null;
  aberturaAt: string | null;
  fechoAt: string;
  qr: { count: number; total: number };
  nfc: { count: number; total: number };
  cash: { count: number; total: number };
  cantina: { count: number; total: number };
  numerario: { count: number; bruto: number; taxa: number; liquido: number };
  totalCount: number;
  totalCve: number;
  taxaPagali: number;
  liquidoComerciante: number;
  notas: string | null;
  estado: string;
}

export interface PosTransacao {
  id: string;
  entidadeNome: string | null;
  terminalNome: string | null;
  montante: number;
  moeda: string;
  descricao: string | null;
  referencia: string;
  estado: string;
  clienteUserId: string | null;
  expiraEm: string | null;
  pagoEm: string | null;
  criadoEm: string;
}

export interface PosRelatorio {
  periodo: { de: string; ate: string };
  porTerminal: Array<{
    terminalId: number | null;
    terminalNome: string;
    pedidos: number;
    pagos: number;
    total: number;
  }>;
  numerario: { operacoes: number; recebido: number; taxa: number; creditado: number; aLiquidar: number };
  fechos: { count: number; total: number };
}

export interface PosFiltros {
  from?: string;
  to?: string;
  entidade?: string;
  terminal?: string;
  estado?: string;
  search?: string;
  page?: number;
  limit?: number;
}

/**
 * Administração do POS Pagali.
 *
 * O menu existia sem rotas por trás, e o backend do POS só tinha endpoints com
 * sessão de terminal. Estas chamadas são a metade de gestão.
 */
export const posAdminService = {
  async terminais(f: PosFiltros = {}): Promise<PosTerminal[]> {
    const { data } = await api.get('/admin/pos/terminais', { params: f });
    return data.data;
  },

  async mudarEstado(id: number, status: 'ACTIVE' | 'INACTIVE' | 'BLOCKED'): Promise<string> {
    const { data } = await api.patch(`/admin/pos/terminais/${id}/estado`, { status });
    return data.message;
  },

  async revogarSessoes(id: number): Promise<string> {
    const { data } = await api.post(`/admin/pos/terminais/${id}/revogar`);
    return data.message;
  },

  async fechos(f: PosFiltros = {}) {
    const { data } = await api.get('/admin/pos/fechos', { params: f });
    return { linhas: data.data as PosFecho[], totais: data.totais, pagination: data.pagination };
  },

  async transacoes(f: PosFiltros = {}) {
    const { data } = await api.get('/admin/pos/transacoes', { params: f });
    return { linhas: data.data as PosTransacao[], totais: data.totais, pagination: data.pagination };
  },

  async relatorios(f: PosFiltros = {}): Promise<PosRelatorio> {
    const { data } = await api.get('/admin/pos/relatorios', { params: f });
    return data.data;
  },
};

export default posAdminService;
